import { Box, styled } from "@leagueplatform/genesis-core";
import { JOURNEY_CONTENT_MAX_WIDTH } from "common/constants";

export const JourneyContentWrapper = styled(Box, {
  maxWidth: JOURNEY_CONTENT_MAX_WIDTH,
  marginInline: "auto",
  width: "100%",
});
